// Default url for the host iframe
export const DefaultProductionIframeUrl = 'https://fluidpreview.office.net/host/';

export const DefaultDevIframeUrl = 'https://dev.fluidpreview.office.net/host/';

// Since office web host could be listening to events from more than one iframe, each post message handler needs a unique id.
// The component load flow uses the component id, which doesn't exist in the preload flow. Instead, we will assign a constant id for the preload flow
export const PreloadPostMessageHandlerId = '__Preload__';
export const ClearStorageMessageHandlerId = '__ClearStorage__';
